<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="30%"
    style="z-index: 10000000"
  >
    <v-card data-testid="alert-dialog" :data-alert-type="alertType">
      <v-card-title data-testid="alert-dialog-title">
        <v-icon
          class="alert-card-title-icon"
          :color="alertType"
          size="18"
        >
          {{ getIcon }}
        </v-icon>
        <span data-testid="alert-dialog-type">{{ alertType.toUpperCase() }}</span>
      </v-card-title>
      <v-card-text>
        <div data-testid="alert-dialog-message">
          <div
            v-for="(line, index) in messageLines"
            :key="index"
            data-testid="alert-dialog-message-line"
          >
            {{ line }}
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          data-testid="alert-dialog-close-button"
          @click="dismissAlert"
        >
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from '../util/EventBus'

export default {
  data(){
    return {
      show: false,
      alertMessage: '',
      alertType: '',
    }
  },
  computed: {
    getIcon() {
      let icon = 'fas fa-bomb'
      switch (this.alertType) {
        case "info":
          icon = 'fas fa-info-circle'
          break
        case "warning":
          icon = 'fas fa-exclamation'
          break
        case "error":
          icon = 'far fa-exclamation-triangle'
          break
      }
      return icon
    },
    /**
     * The message is one newline-joined string (e.g. a title plus validation errors
     * from $handleError); each line is rendered separately so tests can check them
     */
    messageLines() {
      const message = this.alertMessage
      // Same conversion as Vue's {{ }} interpolation: arrays and plain objects as JSON
      const text = message == null
        ? ''
        : Array.isArray(message) || Object.prototype.toString.call(message) === '[object Object]'
          ? JSON.stringify(message, null, 2)
          : String(message)
      return text
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line !== '')
    },

  },
  mounted() {
    EventBus.$on('showalert', this.showAlert)
  },
  methods: {
    showAlert(alert) {
      if(alert) {
        this.alertMessage = alert.message
        this.alertType = alert.type
        this.show = true
      }
    },
    dismissAlert(){
      this.show = false
    }
  }
}
</script>

<style>
.alert-card-title-icon {
  margin-right: 10px;
}
</style>